<template>
  <div>
    <apexchart height="350" :options="chartOptions" :series="series"></apexchart>
  </div>
</template>

<script>
import { ProductService } from "@/services";

export default {
  name: "linechart",
  data: () => ({
    series: [],
    chartOptions: {
      stroke: {
        curve: "smooth",
      },
      title: {
        text: "Sales Product",
        align: "left",
        margin: 0,
        style: {
          fontSize: "19px",
          fontWeight: "bold",
          color: "#344452",
        },
      },
      chart: {
        type: "line",
        zoom: {
          enabled: false,
        },
        toolbar: {
          show: false,
        },
        fontFamily: "Now Alt",
      },
      noData: {
        text: 'Loading...'
      },
      colors: ["#A6CEE3", "#1F78B4", "#B2DF8A"],
      legend: {
        show: true,
        position: "top",
        fontSize: "16px",
        fontWeight: 400,
        horizontalAlign: "right",
        floating: true,
        offsetY: -30,
        offsetX: -5,
        markers: {
          width: 15,
          height: 15,
          radius: 0,
        },
      },
      yaxis: {
        showForNullSeries: false,
        floating: false,
      },
      grid: {
        show: true,
        xaxis: {
          lines: {
            show: true,
          },
        },
        yaxis: {
          lines: {
            show: true,
          },
        },
        row: {
          colors: undefined,
          opacity: 0,
        },
        column: {
          colors: undefined,
          opacity: 0,
        },
      },
    },
  }),
  created() {
    this.initialize();
  },
  methods: {
    async initialize() {
      const chartData = await ProductService.getLineChart();
      const lineInfo = chartData.data;
      const manufacturerdata = lineInfo.manufacturer;
      this.series.push({
        name: 'Manufacturers',
        data: manufacturerdata,
      });
    },
  },
};
</script>
